import moment from "moment";
export const getStringValue = (value) => {
  if (value === 0) return "0";
  if (value) return value.toString();
  return "";
};

export const fetchAge = (dob) => {
  if (!dob) return null;
  return moment().diff(moment(dob), "years", false);
};

export const isValidPhoneNumber = (phoneNumber) => {
  let isValid = true;
  let reg1 = /^(6|7|8|9)[0-9]{9}$/; //check if 10 digits and if starts with 6,7,8,9
  let reg2 = /1{9}|2{9}|3{9}|4{9}|5{9}|6{9}|7{9}|8{9}|9{9}|0{9}/; // check if 9 consequtive digits are same
  if (!RegExp(reg1).test(phoneNumber)) isValid = false;
  if (RegExp(reg2).test(phoneNumber)) isValid = false;
  return isValid;
};

export const formStateHandler = (
  formState,
  fieldName,
  fieldValue,
  isSelect,
  selectedOptions,
  sendOption
  // event
) => {
  let newFormState = { ...formState };
  if (isSelect && selectedOptions) {
    if (Array.isArray(selectedOptions)) {
      if (sendOption) {
        newFormState[fieldName] = selectedOptions;
      } else {
        newFormState[fieldName] = selectedOptions.map((option) => option.id);
        // .join(",");
      }
    } else {
      newFormState[fieldName] = sendOption
        ? selectedOptions
        : selectedOptions.id;
    }
    return newFormState;
  }
  newFormState[fieldName] = fieldValue;
  return newFormState;
};

export const isEmpty = (value) => {
  return value && typeof value === "object"
    ? Object.keys(value).length === 0
    : value === undefined || value === null || value === "";
};

export const isZero = (value) => {
  return value === 0 || value === "0";
};

export const formatNumber = (
  value,
  minimumFractionDigits,
  hasComma = false,
  currency, //INR, USD, SGD
  locale = "hi-IN"
) => {
  if (isEmpty(value) || isNaN(value)) {
    /*console.warn(value, " is not a number.");*/
    value = 0;
  }
  value = parseFloat(value);
  let sign = 1;
  if (value < 0) {
    sign = -1;
    value = -value;
  }
  if (minimumFractionDigits) {
    value = value.toFixed(minimumFractionDigits);
  }
  let numArr = value.toString().split(".");
  let num = numArr[0];
  let fractionVal = numArr[1];
  if (sign < 0) num = "-" + num;
  if (hasComma || currency) {
    if (currency) {
      num = (+num).toLocaleString(locale, {
        minimumFractionDigits: 0,
        style: "currency",
        currency,
      });
    } else {
      num = (+num)
        .toLocaleString(locale, { minimumFractionDigits: 0 })
        .toString();
    }
  }
  if (fractionVal) num = num + "." + fractionVal;
  return num;
};

export const amountFormatter = (params) => {
  return formatNumber(params.value, 2);
};

export const isValidName = (
  name,
  allowNumeric = true,
  allowSpecialChar = true,
  allowFirstSpecialChar = false
) => {
  const numericRegex = /\d/;
  const notAllowedSpecialCharRegex = /[!$^*()|~=`{}[\]:/;<>?,#]/g;
  const specialCharsRegex = /[-!$%^&*()_+|~=`{}[\]:/;<>?,.@#]/g;
  if (!name?.trim()) return false;
  if (!allowNumeric && numericRegex.test(name)) {
    return false;
  }
  if (allowSpecialChar) {
    if (notAllowedSpecialCharRegex.test(name)) return false;
    if (!allowFirstSpecialChar && specialCharsRegex.test(name[0])) return false;
  } else {
    if (specialCharsRegex.test(name)) return false;
  }
  return true;
};

export const checkErrorStateExists = (id, errorState) => {
  return errorState?.findIndex((es) => !!es[id]) !== -1;
};

export const focusInputField = (errorState) => {
  document
    ?.getElementById(Object.keys(errorState[0])[0])
    ?.focus({ preventScroll: true });
};

export const removeErrorState = (id, updatedErrorState, errorState) => {
  updatedErrorState.splice(
    errorState?.findIndex((es) => es[id] === true),
    1
  );
  return updatedErrorState;
};

export const executeScroll = (
  ref,
  block = "nearest",
  behaviour = "smooth",
  inline = "nearest"
) => {
  if (!ref?.current) return;
  ref.current.scrollIntoView({
    block,
    behaviour,
    inline,
  });
};

export const dateFilterComparator = (filterValue, cellValue, format) => {
  if (cellValue == null) return -1;
  const formattedFilterValue = moment(`${filterValue}Z`).format(format);
  const formattedCellValue = moment(`${cellValue}Z`).format(format);

  if (formattedCellValue === formattedFilterValue) {
    return 0;
  }
  if (formattedCellValue < formattedFilterValue) {
    return -1;
  }
  if (formattedCellValue > formattedFilterValue) {
    return 1;
  }
};
export const getISODateTime = (date) => {
  if (typeof date !== "string") return;
  return moment({
    date: date.substr(0, 2),
    month: date.substr(3, 2) - 1,
    year: date.substr(6),
    hour: moment().hour(),
    minute: moment().minute(),
    second: moment().second(),
    millisecond: moment().millisecond(),
  }).toISOString();
};

export const getDeepCopy = (data) =>
  !data ? null : JSON.parse(JSON.stringify(data));

export const cleanObject = (data) => {
  if (typeof data !== "object" || data === null) return data;

  return Object.entries(data).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {});
};
